import { Stack } from "@mui/material";

import { OpenDrawerMenuButton } from "components/Carrier/components/OpenDrawerMenuButton";
import { DrawerMenu } from "components/DrawerMenu";
import { DashboardBackButton } from "components/Shipment/components/DashboardBackButton";
import { useDisclosure } from "hooks";
import { useIsMobile } from "hooks/useIsMobile";
import { PageLayout } from "layouts";

import { SupplierShipmentsSidebar } from "../SupplierShipmentsSidebar";

interface Props {
  supplierShipmentOverview: React.ReactNode;
  supplierShipments: SupplierShipment[];
  shipmentSelectionIsDisabled: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
  shipmentCount: number;
}

export function SupplierShipment(props: Props) {
  const {
    supplierShipmentOverview,
    supplierShipments,
    shipmentSelectionIsDisabled,
    handlePageSelected,
    page,
    pages,
    shipmentCount,
  } = props;

  const showFullSidebar = !useIsMobile({ maxWidth: 1200 });
  const { isOpen, onOpen, onClose } = useDisclosure(false);

  const supplierShipmentBrowser = (
    <SupplierShipmentsSidebar
      supplierShipments={supplierShipments}
      shipmentSelectionIsDisabled={shipmentSelectionIsDisabled}
      page={page}
      pages={pages}
      handlePageSelected={handlePageSelected}
      shipmentCount={shipmentCount}
      showDashboardBackButton={showFullSidebar}
    />
  );

  return (
    <PageLayout>
      {!showFullSidebar && (
        <Stack direction="column">
          <DashboardBackButton />
          <OpenDrawerMenuButton
            onOpen={onOpen}
            buttonLabel="SUPPLIER SHIPMENTS"
          />
        </Stack>
      )}
      <Stack direction="row" spacing={showFullSidebar ? 2 : undefined}>
        {showFullSidebar && (
          <Stack width="25%">{supplierShipmentBrowser}</Stack>
        )}
        <Stack spacing={showFullSidebar ? 2 : undefined} flex={1}>
          {!showFullSidebar && (
            <DrawerMenu isOpen={isOpen} onClose={onClose}>
              {supplierShipmentBrowser}
            </DrawerMenu>
          )}
          {supplierShipmentOverview}
        </Stack>
      </Stack>
    </PageLayout>
  );
}
